import { CloudComponent } from './cloud';

export * from './cloud';


export const CloudAtoms = [
    CloudComponent
]